module.exports = __webpack_public_path__ + "img/20200508_175932.635095b5.jpg";